import { render, staticRenderFns } from "./AppManagement.vue?vue&type=template&id=9b8f14aa&scoped=true"
import script from "./AppManagement.vue?vue&type=script&lang=js"
export * from "./AppManagement.vue?vue&type=script&lang=js"
import style0 from "./AppManagement.vue?vue&type=style&index=0&id=9b8f14aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8f14aa",
  null
  
)

export default component.exports